import Api from './index';
import {
  UserFavorite,
  UserSetting,
  UserSettingTypes,
  BookCode,
  ProductCopyrightTerms,
  FtueTour
} from 'types';

const routePrefix = '/users/me';

const getUserProfile = (params?: any) => {
  return Api.get(routePrefix, { params });
};
const getUserFavorites = (params?: any) => {
  return Api.get(`${routePrefix}/favorites`, { params });
};

const createUserFavorite = (data: UserFavorite) => {
  return Api.post(`${routePrefix}/favorites`, { data });
};

const deleteUserFavorite = (id: number) => {
  return Api.destroy(`${routePrefix}/favorites/${id}`);
};

const getUserSettings = () => {
  return Api.get(`${routePrefix}/settings`);
};

const updateUserSetting = (type: UserSettingTypes, data: UserSetting) => {
  return Api.put(`${routePrefix}/settings/${type}`, { data });
};

const updateClickAwayAccess = (bookCode: BookCode, edition: number) => {
  return Api.put(`${routePrefix}/access/click-aways`, { data: { bookCode, edition } });
};

const updateProductAccess = (productCurriculumId: number) => {
  return Api.put(`${routePrefix}/access/products`, { data: { productCurriculumId } });
};

const getCopyrightTerms = () => {
  return Api.get(`${routePrefix}/copyright-terms`);
};

const updateCopyrightTerms = (data: ProductCopyrightTerms) => {
  return Api.put(`${routePrefix}/copyright-terms`, { data });
};

const getUserTourSteps = params => {
  return Api.get(`${routePrefix}/tour`, { params });
};

const updateTourStep = (data: Array<FtueTour>) => {
  return Api.put(`${routePrefix}/tour`, { data });
};

const saveTeachingOrderStartDateSetting = (startDate: string) => {
  return Api.put(`${routePrefix}/start-date`, {
    data: {
      startDate
    }
  });
};

export {
  getUserProfile,
  getUserFavorites,
  createUserFavorite,
  deleteUserFavorite,
  getUserSettings,
  updateUserSetting,
  updateClickAwayAccess,
  updateProductAccess,
  getCopyrightTerms,
  updateCopyrightTerms,
  getUserTourSteps,
  updateTourStep,
  saveTeachingOrderStartDateSetting
};
